import { render } from "./CenterCreateRoles.vue?vue&type=template&id=5300bb08&ts=true"
import script from "./CenterCreateRoles.vue?vue&type=script&lang=ts"
export * from "./CenterCreateRoles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Center/CenterCreateRoles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5300bb08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5300bb08', __exports__)) {
    api.reload('5300bb08', __exports__)
  }
  
  module.hot.accept("./CenterCreateRoles.vue?vue&type=template&id=5300bb08&ts=true", () => {
    api.rerender('5300bb08', render)
  })

}


export default __exports__